// TODO: use individual polyfillss. yeah, that's bad but I don't have
// either time nor PC to hunt down IE 9/11 issues
import 'babel-polyfill';
// import 'core-js/es6/map';
// import 'core-js/es6/set';
// import 'core-js/fn/array/find';

import React from 'react';
import { render } from 'react-dom';
import App from './App';
import './semantic/dist/semantic.min.css';
import './robotex.css';
import Amplify from "aws-amplify";
import { CookiesProvider } from 'react-cookie';

import { initLogger } from './common/utils';
import { initI18n, amplify_conf } from './conf';


initLogger('https://970d4408a3ba486381102975c9806b95@sentry.io/1294871');
initI18n();
Amplify.configure(amplify_conf);

render((
  <CookiesProvider>
    <App/>
  </CookiesProvider>
), document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js